import React, { useState, useEffect } from 'react';
import { Box, FormControl, InputLabel, Select, MenuItem, Grid, Button } from '@mui/material';
import FilterListOffIcon from '@mui/icons-material/FilterListOff';

import {
    cargarRegiones,
    cargarProvincias,
    cargarDistritos,
    cargarIe
} from '../../../components/buscador/sesion.search';

export default function FiltrosUbicacion({ filtros, setFiltros }) {
    const [opcionesRegion, setOpcionesRegion] = useState([]);
    const [opcionesProvincia, setOpcionesProvincia] = useState([]);
    const [opcionesDistrito, setOpcionesDistrito] = useState([]);
    const [opcionesIIEE, setOpcionesIIEE] = useState([]);

    useEffect(() => {
        const fetchRegiones = async () => {
            try {
                const response = await cargarRegiones();
                console.log("👀 Respuesta cruda de Regiones:", response);
                const dataLimpia = Array.isArray(response) ? response : (response?.data || []);

                setOpcionesRegion(dataLimpia);
            } catch (error) {
                console.error("Error al cargar regiones:", error);
            }
        };
        fetchRegiones();
    }, []);

    useEffect(() => {
        const fetchProvincias = async () => {
            if (filtros.region) {
                try {
                    const response = await cargarProvincias(filtros.region);
                    const dataLimpia = Array.isArray(response) ? response : (response?.data || []);
                    setOpcionesProvincia(dataLimpia);
                } catch (error) {
                    console.error("Error al cargar provincias:", error);
                }
            } else {
                setOpcionesProvincia([]);
            }
        };
        fetchProvincias();
    }, [filtros.region]);

    useEffect(() => {
        const fetchDistritos = async () => {
            if (filtros.provincia) {
                try {
                    const response = await cargarDistritos(filtros.provincia);
                    const dataLimpia = Array.isArray(response) ? response : (response?.data || []);
                    setOpcionesDistrito(dataLimpia);
                } catch (error) {
                    console.error("Error al cargar distritos:", error);
                }
            } else {
                setOpcionesDistrito([]);
            }
        };
        fetchDistritos();
    }, [filtros.provincia]);

    useEffect(() => {
        const fetchIIEE = async () => {
            if (filtros.distrito) {
                try {
                    const paramsParaBackend = {
                        codigo_ubigeo: filtros.distrito
                    };

                    const response = await cargarIe(paramsParaBackend);

                    const dataLimpia = Array.isArray(response) ? response : (response?.data || []);
                    setOpcionesIIEE(dataLimpia);
                } catch (error) {
                    console.error("Error al cargar II.EE.:", error);
                }
            } else {
                setOpcionesIIEE([]);
            }
        };
        fetchIIEE();
    }, [filtros.distrito]);

    const handleChangeRegion = (e) => {
        const val = e.target.value;
        const nombre = opcionesRegion.find(r => String(r.id) === String(val))?.nombre || '';

        setFiltros({
            ...filtros,
            region: val,
            regionNombre: nombre,
            provincia: '',
            provinciaNombre: '',
            distrito: '',
            distritoNombre: '',
            iiee: ''
        });
    };

    const handleChangeProvincia = (e) => {
        const val = e.target.value;
        const nombre = opcionesProvincia.find(p => String(p.id) === String(val))?.nombre || '';

        setFiltros({
            ...filtros,
            provincia: val,
            provinciaNombre: nombre,
            distrito: '',
            distritoNombre: '',
            iiee: ''
        });
    };

    const handleChangeDistrito = (e) => {
        const val = e.target.value;
        const nombre = opcionesDistrito.find(d => String(d.id) === String(val))?.nombre || '';

        setFiltros({
            ...filtros,
            distrito: val,
            distritoNombre: nombre,
            iiee: ''
        });
    };

    const handleChangeIIEE = (e) => {
        setFiltros({ ...filtros, iiee: e.target.value });
    };

    const limpiarFiltros = () => {
        setFiltros({
            region: '', regionNombre: '',
            provincia: '', provinciaNombre: '',
            distrito: '', distritoNombre: '',
            iiee: ''
        });
    };


    return (
        <Box sx={{ flexGrow: 1, mb: 4, p: 3, bgcolor: 'white', borderRadius: 2, boxShadow: '0 2px 10px rgba(0,0,0,0.05)' }}>
            <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} sm={6} md={2.5}>
                    <FormControl fullWidth size="small">
                        <InputLabel shrink id="label-region">Región</InputLabel>
                        <Select displayEmpty labelId="label-region" value={filtros.region} label="Región" onChange={handleChangeRegion}>
                            <MenuItem value=""><em>Todas</em></MenuItem>
                            {opcionesRegion?.map(reg => (
                                <MenuItem key={reg.id} value={reg.id}>{reg.nombre}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>

                <Grid item xs={12} sm={6} md={2.5}>
                    <FormControl fullWidth size="small" disabled={!filtros.region}>
                        <InputLabel shrink id="label-provincia">Provincia</InputLabel>
                        <Select displayEmpty labelId="label-provincia" value={filtros.provincia} label="Provincia" onChange={handleChangeProvincia}>
                            <MenuItem value=""><em>Todas</em></MenuItem>
                            {opcionesProvincia?.map(prov => (
                                <MenuItem key={prov.id} value={prov.id}>{prov.nombre}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>

                <Grid item xs={12} sm={6} md={2.5}>
                    <FormControl fullWidth size="small" disabled={!filtros.provincia}>
                        <InputLabel shrink id="label-distrito">Distrito</InputLabel>
                        <Select displayEmpty labelId="label-distrito" value={filtros.distrito} label="Distrito" onChange={handleChangeDistrito}>
                            <MenuItem value=""><em>Todos</em></MenuItem>
                            {opcionesDistrito?.map(dist => (
                                <MenuItem key={dist.id} value={dist.id}>{dist.nombre}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                    <FormControl fullWidth size="small" disabled={!filtros.distrito}>
                        <InputLabel shrink id="label-iiee">II.EE.</InputLabel>
                        <Select displayEmpty labelId="label-iiee" value={filtros.iiee} label="II.EE." onChange={handleChangeIIEE}>
                            <MenuItem value=""><em>Todas</em></MenuItem>
                            {opcionesIIEE?.map(ie => (
                                <MenuItem key={ie.id} value={ie.id}>{ie.nombre} ({ie.nivel_modalidad})</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>

                <Grid item xs={12} md={1.5} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button
                        variant="outlined"
                        color="secondary"
                        onClick={limpiarFiltros}
                        startIcon={<FilterListOffIcon />}
                        disabled={!filtros.region}
                        fullWidth
                    >
                        Limpiar
                    </Button>
                </Grid>

            </Grid>
        </Box>
    );
}
